<div class="container" matomoForm="payment-hub-navigation">
  <mat-card>
    <div fxLayout="row" fxLayout.lt-md="column" class="payment-hub-ee-wrap">
      <div fxFlex="50%"
      *ngIf="canViewTransfers() || canExportTransfers()"
      >
        <mat-nav-list>
          <mat-list-item
            *ngIf="canViewTransfers()"
            [routerLink]="['incomingtransactions']"
            (click)="onNavigateToSection('Incoming Transactions', 'Search')"
            matomoClick="navigation-incoming-transactions"
            category="Payment Hub Navigation"
            name="Search Incoming Transactions"
          >
            <mat-icon matListIcon>
              <fa-icon icon="search" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.INCOMING_TRANSACTIONS.SEARCH" | translate }}
            </h4>
            <p matLine>
              {{
                "PAYMENT_HUB.INCOMING_TRANSACTIONS.SEARCH_DESCRIPTION"
                  | translate
              }}
            </p>
          </mat-list-item>

          <mat-list-item
            *ngIf="canViewTransfers()"
            [routerLink]="['outgoingtransactions']"
            (click)="onNavigateToSection('Outgoing Transactions', 'Search')"
            matomoClick="navigation-outgoing-transactions"
            category="Payment Hub Navigation"
            name="Search Outgoing Transactions"
          >
            <mat-icon matListIcon>
              <fa-icon icon="search" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.OUTGOING_TRANSACTIONS.SEARCH" | translate }}
            </h4>
            <p matLine>
              {{
                "PAYMENT_HUB.OUTGOING_TRANSACTIONS.SEARCH_DESCRIPTION"
                  | translate
              }}
            </p>
          </mat-list-item>

          <mat-list-item
            *ngIf="canExportTransfers()"
            [routerLink]="['incomingtransactionexport']"
            (click)="onExportAction('Incoming Transactions')"
            matomoClick="export-incoming-transactions"
            category="Export Actions"
            name="Export Incoming Transactions"
          >
            <mat-icon matListIcon>
              <fa-icon icon="download" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.INCOMING_TRANSACTIONS.EXPORT" | translate }}
            </h4>
          </mat-list-item>

        </mat-nav-list>
      </div>

      <div fxFlex="50%"
      *ngIf="canViewTransactions() || canExportTransactions()"
      >
        <mat-nav-list>
          <mat-list-item
            *ngIf="canViewTransactions()"
            [routerLink]="['incomingrequesttopay']"
            (click)="onNavigateToSection('Incoming Request to Pay', 'Search')"
            matomoClick="navigation-incoming-rtp"
            category="Payment Hub Navigation"
            name="Search Incoming Request to Pay"
          >
            <mat-icon matListIcon>
              <fa-icon icon="search" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.INCOMING_REQUEST_TO_PAY.SEARCH" | translate }}
            </h4>
            <p matLine>
              {{
                "PAYMENT_HUB.INCOMING_REQUEST_TO_PAY.SEARCH_DESCRIPTION"
                  | translate
              }}
            </p>
          </mat-list-item>

          <mat-list-item
            *ngIf="canViewTransactions()"
            [routerLink]="['outgoingrequesttopay']"
            (click)="onNavigateToSection('Outgoing Request to Pay', 'Search')"
            matomoClick="navigation-outgoing-rtp"
            category="Payment Hub Navigation"
            name="Search Outgoing Request to Pay"
          >
            <mat-icon matListIcon>
              <fa-icon icon="search" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.OUTGOING_REQUEST_TO_PAY.SEARCH" | translate }}
            </h4>
            <p matLine>
              {{
                "PAYMENT_HUB.OUTGOING_REQUEST_TO_PAY.SEARCH_DESCRIPTION"
                  | translate
              }}
            </p>
          </mat-list-item>

          <mat-list-item
            *ngIf="canExportTransactions()"
            [routerLink]="['incomingrequesttopayexport']"
            (click)="onExportAction('Incoming Request to Pay')"
            matomoClick="export-incoming-rtp"
            category="Export Actions"
            name="Export Incoming Request to Pay"
          >
            <mat-icon matListIcon>
              <fa-icon icon="download" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>
              {{ "PAYMENT_HUB.INCOMING_REQUEST_TO_PAY.EXPORT" | translate }}
            </h4>
          </mat-list-item>
        </mat-nav-list>
      </div>
      <div fxFlex="50%">
        <mat-nav-list>
          <mat-list-item
            [routerLink]="['getbatchexport']"
            (click)="onNavigateToSection('Batches', 'Export')"
            matomoClick="navigation-batches"
            category="Payment Hub Navigation"
            name="Batches Export"
          >
            <mat-icon matListIcon>
              <fa-icon icon="download" size="sm"></fa-icon>
            </mat-icon>
            <h4 matLine>{{ "PAYMENT_HUB.BATCHES.TITLE" | translate }}</h4>
          </mat-list-item>
        </mat-nav-list>
      </div>
    </div>
  </mat-card>
</div>
